import {
  GET_AUTH_USER,
  GET_AUTH_USER_OK,
  GET_AUTH_USER_ERR,
} from "./actionTypes"
import { GetUserResponse } from "~/types/backend";

/********** LOGIN **********/

export const getAuthUser = () => ({
  type: GET_AUTH_USER,
});

export const getAuthUserOk = (response: GetUserResponse) => ({
  type: GET_AUTH_USER_OK,
  payload: { response },
});

export const getAuthUserErr = (error: Error) => ({
  type: GET_AUTH_USER_ERR,
  payload: { error },
});